import React from 'react';
import PropTypes from 'prop-types';

function AnalyticsSummaryBlock({ title, value, prefix = '' }) {
  return (
    <div className="analytics-content-summary-item">
      <h5 className="analytics-content-summary-item-title">{title}</h5>
      <h3 className="analytics-content-summary-item-value">
        {prefix} {value}
      </h3>
    </div>
  );
}

AnalyticsSummaryBlock.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  prefix: PropTypes.string,
};

AnalyticsSummaryBlock.defaultProps = {
  prefix: '',
};

export default AnalyticsSummaryBlock;
